import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";

import MenuVertical from "./menus/menu-vertical";
import { Container } from "reactstrap";

import logoSm from "../assets/images/logo-sm.png";
import logoLight from "../assets/images/logo-light.png";

const Sidebar = ({ layoutType }) => {
    useEffect(() => {
        var verticalOverlay = document.getElementsByClassName("vertical-overlay");
        if (verticalOverlay) {
            verticalOverlay[0].addEventListener("click", function () {
                document.body.classList.remove("vertical-sidebar-enable");
            });
        }
    });

    const addEventListenerOnSmHoverMenu = () => {
        if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
            document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
        } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
            document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
        } else {
            document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
        }
    };

    return (
        <React.Fragment>
            <div className="app-menu navbar-menu">
                <div className="navbar-brand-box">
                    <Link to="/" className="logo logo-light">
                        <span className="logo-sm">
                            {/* <img src={logoSm} alt="" height="22" /> */}
                            <img src={logoSm} alt="" height="37" />
                        </span>
                        <span className="logo-lg">
                            {/* <img src={logoLight} alt="" height="17" /> */}
                            <img src={logoLight} alt="" height="32" />
                        </span>
                    </Link>
                    <button id="vertical-hover"
                        onClick={addEventListenerOnSmHoverMenu}
                        className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
                        type="button"
                    >
                        <i className="ri-record-circle-line"></i>
                    </button>
                </div>
                <SimpleBar id="scrollbar" className="h-100">
                    <Container fluid>
                        <div id="two-column-menu"></div>
                        <ul className="navbar-nav" id="navbar-nav">
                            <MenuVertical layoutType={layoutType} />
                        </ul>
                    </Container>
                </SimpleBar>
                <div className="sidebar-background"></div>
            </div>
            <div className="vertical-overlay"></div>
        </React.Fragment>
    );
};

export default Sidebar;
